module.exports = __webpack_public_path__ + "img/lottery_getBtn.fbe35f74.png";